export const formatMoney = (
  amount: number,
  currency: string | undefined | null
) =>
  amount.toLocaleString("en-AU", {
    style: "currency",
    currency: currency || "AUD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
